import React from 'react';
import cn from 'clsx';

import Typography from '../../../../library/typography/typography';
import FoundItLowerButton from '../../../../components/found-it-lower-button/found-it-lower-button';
import ParentProductMessage from '../../../../components/parent-product-message/parent-product-message';
import ProductQuantity from '../../../../components/product-quantity/product-quantity';
import ProductListCardPrice from '../product-list-card-price/product-list-card-price';

import {
  getProductFitmentPosition,
  isWindShieldWiperProduct
} from '../../../../shared/utils/product/product';

import { ProductData } from '../../../../shared/types/graphql-types';

import styles from './product-list-set-card-position.scss';

interface ProductListSetCardPositionProps {
  index?: number;
  isCanonical?: boolean;
  onQuantityChange: (quantity: number, index?: number) => void;
  product: ProductData;
  quantity: number;
  totalQuantity: number;
}

function ProductListSetCardPosition(props: ProductListSetCardPositionProps) {
  const {
    index,
    isCanonical,
    onQuantityChange,
    product,
    quantity,
    totalQuantity
  } = props;
  const isWindShieldWiper = isWindShieldWiperProduct(product);
  const productFitmentPosition = getProductFitmentPosition(product);

  function handleQuantityChange(_, updatedValue) {
    onQuantityChange(updatedValue, index);
  }

  return (
    <div className={styles['container']}>
      {product.size && (
        <Typography
          className={cn(styles['label'], 'product-set-description__label')}
          tag="div"
          weight="black"
        >
          {productFitmentPosition ? productFitmentPosition : 'SIZE'}:
          <Typography tag="span">&nbsp;{product.size}&quot;</Typography>
        </Typography>
      )}

      <div className={styles['price-qty-container']}>
        <ProductListCardPrice
          hideFoundItLower
          hideParentMessage
          hidePercentageSaved
          product={product}
          quantity={quantity}
          totalQuantity={totalQuantity}
        />

        {!isCanonical && (
          <ProductQuantity
            defaultValue={isWindShieldWiper ? 1 : 2}
            id="quantity"
            onBlur={handleQuantityChange}
            onChange={handleQuantityChange}
            showLabel
            value={quantity}
          />
        )}
      </div>
      <FoundItLowerButton
        productItem={{
          product: product,
          quantity: quantity,
          totalQuantity: totalQuantity
        }}
      />
      <ParentProductMessage
        className={styles['parent-product-message']}
        product={product}
      />
    </div>
  );
}

export default ProductListSetCardPosition;
